(function () {
    'use strict';

    var UMBRAL_SWIPE = 35;
    var UMBRAL_AXIS_LOCK = 5;
    var QUERY_NO_TACTIL = '(hover: hover) and (pointer: fine)';

    // Micro-sistema de encolado para evitar Layout Thrashing
    var escriturasPendientes = [];
    var rafEscrituraActivo = false;

    function encolarEscritura(fn) {
        escriturasPendientes.push(fn);
        if (!rafEscrituraActivo) {
            rafEscrituraActivo = true;
            requestAnimationFrame(function procesarEscrituras() {
                var tareas = escriturasPendientes.slice();
                escriturasPendientes = [];
                rafEscrituraActivo = false;
                for (var i = 0; i < tareas.length; i++) {
                    tareas[i]();
                }
            });
        }
    }

    function esNoTactil() {
        return window.matchMedia(QUERY_NO_TACTIL).matches;
    }

    function iniciarNoTactil(seccion) {
        var tarjetas = Array.from(seccion.querySelectorAll('.oferta-swipe__tarjeta'));

        if (tarjetas.length === 0) return;

        encolarEscritura(function () {
            tarjetas.forEach(function (tarjeta) {
                tarjeta.style.cssText = '';
                tarjeta.setAttribute('tabindex', '0');
                tarjeta.classList.remove(
                    'oferta-swipe__tarjeta--arrastrando',
                    'oferta-swipe__tarjeta--presionada',
                    'oferta-swipe__tarjeta--rebote',
                    'oferta-swipe__tarjeta--activa',
                    'oferta-swipe__tarjeta--saliendo',
                    'oferta-swipe__tarjeta--oculta'
                );
            });
        });

        function accionarEnlace(e) {
            if (!esNoTactil()) return;
            var link = e.currentTarget.getAttribute('data-url');
            if (link) {
                e.preventDefault();
                window.location.href = link;
            }
        }

        tarjetas.forEach(function (tarjeta) {
            tarjeta.addEventListener('click', accionarEnlace);
            tarjeta.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') accionarEnlace(e);
            });
        });

        return {
            destruir: function () {
                encolarEscritura(function () {
                    tarjetas.forEach(function (tarjeta) {
                        tarjeta.replaceWith(tarjeta.cloneNode(true));
                    });
                });
            }
        };
    }

    function iniciarMobile(seccion) {
        var viewport = seccion.querySelector('.oferta-swipe__viewport');
        var tarjetas = Array.from(seccion.querySelectorAll('.oferta-swipe__tarjeta'));
        var total = tarjetas.length;
        var tarjetaActual = 0;
        var arrastrando = false;
        var presionando = false;
        var bloqueadoPorArrastre = false;
        var scrollPosicionInicial = 0;

        if (!viewport || total === 0) return null;

        // Observer de visibilidad para el botón Sticky nativo
        var seccionVisible = false;
        var visibilidadObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                seccionVisible = entry.isIntersecting;
                gestionarBotonesSticky();
            });
        }, { threshold: 0.3 }); // Activa si la sección está 30% visible
        visibilidadObserver.observe(seccion);

        function gestionarBotonesSticky() {
            var tarjetaActiva = tarjetas[tarjetaActual];
            var idEspecial = tarjetaActiva ? tarjetaActiva.getAttribute('data-tarjeta-especial-id') : null;

            encolarEscritura(function () {
                // Buscamos directamente el componente <product-form> inyectado
                var botones = seccion.querySelectorAll('product-form.sticky-swipe-btn');
                botones.forEach(function (btn) {
                    if (seccionVisible && idEspecial && btn.id === 'sticky-swipe-' + idEspecial) {
                        btn.classList.add('is-visible');
                        btn.setAttribute('aria-hidden', 'false');
                    } else {
                        btn.classList.remove('is-visible');
                        btn.setAttribute('aria-hidden', 'true');
                    }
                });
            });
        }

        if (typeof EmblaCarousel !== 'undefined') {
            EmblaCarousel(viewport, { watchDrag: false, active: false });
        }

        function calcularOffset(indice, base) {
            var offset = indice - base;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;
            return offset;
        }

        function aplicarEstilos(tarjeta, offset, zIndexOverride) {
            var esColeccion = tarjeta.classList.contains('oferta-swipe__tarjeta--coleccion');
            var offsetBase = esColeccion ? 90 : 60;
            var scaleBase = 1;
            var translateYBase = 0;

            if (esColeccion) {
                if (Math.abs(offset) === 1) { scaleBase = 0.78; translateYBase = 12; }
                else if (Math.abs(offset) === 2) { scaleBase = 0.62; translateYBase = 20; }
                else if (Math.abs(offset) > 2) { scaleBase = 0.5; translateYBase = 28; }
            } else {
                scaleBase = offset === 0 ? 1 : 0.85;
            }

            var translateX = offset * offsetBase;
            var zIndex = zIndexOverride !== undefined ? zIndexOverride : (total - Math.abs(offset));
            var transformValue = 'translateX(' + translateX + 'px) scale(' + scaleBase + ')' + (translateYBase > 0 ? ' translateY(' + translateYBase + 'px)' : '');

            // Todo encapsulado para ejecutar en un solo frame
            encolarEscritura(function () {
                tarjeta.style.transform = transformValue;
                tarjeta.style.zIndex = zIndex;
                tarjeta.style.pointerEvents = offset === 0 ? 'auto' : 'none';
                tarjeta.classList.toggle('oferta-swipe__tarjeta--activa', offset === 0);
                tarjeta.setAttribute('tabindex', offset === 0 ? '0' : '-1');
            });
        }

        function posicionar() {
            tarjetas.forEach(function (tarjeta, indice) {
                encolarEscritura(function () { tarjeta.style.transition = ''; });
                aplicarEstilos(tarjeta, calcularOffset(indice, tarjetaActual));
            });
            gestionarBotonesSticky();
        }

        function irA(nuevoIndice) {
            var anteriorIndice = tarjetaActual;
            tarjetaActual = (nuevoIndice + total) % total;

            tarjetas.forEach(function (tarjeta, indice) {
                var offsetAnterior = calcularOffset(indice, anteriorIndice);
                var offsetNuevo = calcularOffset(indice, tarjetaActual);
                var esWrap = (offsetAnterior < 0 && offsetNuevo > 0) || (offsetAnterior > 0 && offsetNuevo < 0);

                if (esWrap) {
                    encolarEscritura(function () { tarjeta.style.transition = 'none'; });
                    aplicarEstilos(tarjeta, offsetNuevo, 0);

                    // Devolver transición limpiamente en siguientes frames
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            encolarEscritura(function () {
                                tarjeta.style.transition = 'z-index 0ms 100ms';
                                tarjeta.style.zIndex = total - Math.abs(offsetNuevo);
                            });
                        });
                    });
                } else {
                    encolarEscritura(function () { tarjeta.style.transition = ''; });
                    aplicarEstilos(tarjeta, offsetNuevo);
                }
            });
            resetearScrollSafari();
            gestionarBotonesSticky();
        }

        function siguiente() { irA(tarjetaActual + 1); }
        function anterior() { irA(tarjetaActual - 1); }

        function quitarPresion() {
            presionando = false;
            encolarEscritura(function () {
                tarjetas.forEach(function (tarjeta) {
                    tarjeta.classList.remove('oferta-swipe__tarjeta--presionada');
                });
            });
        }

        function aplicarRebote(tarjeta) {
            encolarEscritura(function () {
                tarjeta.classList.remove('oferta-swipe__tarjeta--presionada');
                tarjeta.classList.add('oferta-swipe__tarjeta--rebote');
            });
            tarjeta.addEventListener('animationend', function limpiar() {
                encolarEscritura(function () { tarjeta.classList.remove('oferta-swipe__tarjeta--rebote'); });
                tarjeta.removeEventListener('animationend', limpiar);
            });
        }

        function resetearScrollSafari() {
            var targetScrollX = window.scrollX; // Lectura única sincrona
            var targetScrollY = scrollPosicionInicial;

            encolarEscritura(function () {
                window.scrollTo(targetScrollX, targetScrollY);
                requestAnimationFrame(function () {
                    window.scrollTo(targetScrollX, targetScrollY);
                });
            });
        }

        var touch = {
            startX: 0, startY: 0, currentX: 0, currentY: 0,
            deltaX: 0, deltaY: 0, direccion: null,
            inicioCapturado: false, ultimoTiempo: 0
        };

        function onTouchStart(e) {
            if (esNoTactil()) return;
            scrollPosicionInicial = window.scrollY || window.pageYOffset; // Lectura
            var t = e.touches[0];
            touch.startX = t.clientX; touch.startY = t.clientY;
            touch.currentX = t.clientX; touch.currentY = t.clientY;
            touch.direccion = null; touch.inicioCapturado = true;
            touch.ultimoTiempo = Date.now();
            arrastrando = false; bloqueadoPorArrastre = false;
            quitarPresion();
            encolarEscritura(function () {
                tarjetas[tarjetaActual].classList.remove('oferta-swipe__tarjeta--rebote');
            });
        }

        function onTouchMove(e) {
            if (esNoTactil() || !touch.inicioCapturado) return;

            var t = e.touches[0];
            touch.currentX = t.clientX;
            touch.currentY = t.clientY;
            touch.deltaX = touch.currentX - touch.startX;
            touch.deltaY = touch.currentY - touch.startY;

            var absX = Math.abs(touch.deltaX);
            var absY = Math.abs(touch.deltaY);

            if (touch.direccion === null && (absX >= UMBRAL_AXIS_LOCK || absY >= UMBRAL_AXIS_LOCK)) {
                touch.direccion = (absX > absY * 2) ? 'horizontal' : 'vertical';
            }

            if (touch.direccion === 'vertical') {
                if (arrastrando) {
                    arrastrando = false;
                    encolarEscritura(function () {
                        var tf = tarjetas[tarjetaActual];
                        tf.classList.remove('oferta-swipe__tarjeta--arrastrando');
                        tf.style.transition = '';
                    });
                    posicionar();
                }
                return;
            }

            if (touch.direccion === 'horizontal') {
                if (e.cancelable) { e.preventDefault(); e.stopPropagation(); }

                if (!arrastrando) {
                    arrastrando = true;
                    bloqueadoPorArrastre = true;
                    encolarEscritura(function () {
                        var tf = tarjetas[tarjetaActual];
                        tf.classList.remove('oferta-swipe__tarjeta--rebote');
                        tf.classList.add('oferta-swipe__tarjeta--arrastrando');
                        tf.style.transition = 'box-shadow 0.2s ease';
                    });
                }

                // Cálculo puro, la escritura se va a la cola
                var rot = touch.deltaX / 20;
                var transX = touch.deltaX;

                encolarEscritura(function () {
                    tarjetas[tarjetaActual].style.transform = 'translateX(' + transX + 'px) rotate(' + rot + 'deg) scale(0.975)';
                });
            }
        }

        function onTouchEnd() {
            if (esNoTactil() || !touch.inicioCapturado) return;

            if (!arrastrando) {
                touch.inicioCapturado = false;
                return;
            }

            encolarEscritura(function () {
                var tf = tarjetas[tarjetaActual];
                tf.style.transition = '';
                tf.classList.remove('oferta-swipe__tarjeta--arrastrando');
            });

            var velocidad = Math.abs(touch.deltaX) / (Date.now() - touch.ultimoTiempo);
            if ((velocidad > 0.3 || Math.abs(touch.deltaX) > UMBRAL_SWIPE) && Math.abs(touch.deltaX) > Math.abs(touch.deltaY)) {
                touch.deltaX < 0 ? siguiente() : anterior();
            } else {
                posicionar();
                resetearScrollSafari();
            }

            arrastrando = false;
            touch.inicioCapturado = false;
            setTimeout(function () { bloqueadoPorArrastre = false; }, 100);
        }

        viewport.addEventListener('touchstart', onTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
        viewport.addEventListener('touchend', onTouchEnd, { passive: true, capture: true });

        viewport.addEventListener('pointermove', function (e) {
            if (!esNoTactil() && arrastrando && touch.direccion === 'horizontal' && e.cancelable) {
                e.preventDefault();
            }
        }, { passive: false });

        tarjetas.forEach(function (tarjeta, indice) {
            var pressTimer = null;

            function ejecutarEnlace(e) {
                if (esNoTactil() || bloqueadoPorArrastre || indice !== tarjetaActual) return;
                var link = tarjeta.getAttribute('data-url');
                if (link) {
                    e.preventDefault();
                    encolarEscritura(function () { tarjeta.classList.add('oferta-swipe__tarjeta--presionada'); });
                    setTimeout(function () {
                        aplicarRebote(tarjeta);
                        setTimeout(function () { window.location.href = link; }, 300);
                    }, 120);
                }
            }

            tarjeta.addEventListener('click', ejecutarEnlace);
            tarjeta.addEventListener('touchstart', function () {
                if (esNoTactil() || indice !== tarjetaActual) return;
                pressTimer = setTimeout(function () {
                    presionando = true;
                    encolarEscritura(function () {
                        tarjeta.classList.remove('oferta-swipe__tarjeta--rebote');
                        tarjeta.classList.add('oferta-swipe__tarjeta--presionada');
                    });
                }, 500);
            }, { passive: true });

            tarjeta.addEventListener('touchend', function () {
                clearTimeout(pressTimer);
                if (presionando && indice === tarjetaActual) aplicarRebote(tarjeta);
            }, { passive: true });
        });

        // Evento scroll ultra-optimizado: separa la lectura de la escritura.
        var scrollMonitorTimeout;
        window.addEventListener('scroll', function () {
            if (esNoTactil()) return;
            clearTimeout(scrollMonitorTimeout);

            if (arrastrando) {
                var currentX = window.scrollX; // Lectura síncrona
                var targetY = scrollPosicionInicial;
                encolarEscritura(function () {
                    window.scrollTo(currentX, targetY); // Escritura diferida
                });
            } else {
                scrollMonitorTimeout = setTimeout(function () {
                    if (!arrastrando) scrollPosicionInicial = window.scrollY || window.pageYOffset;
                }, 100);
            }
        }, { passive: true });

        posicionar();

        return {
            posicionar: posicionar,
            limpiar: function () {
                visibilidadObserver.disconnect();
                encolarEscritura(function () {
                    tarjetas.forEach(function (t) {
                        t.style.cssText = '';
                        t.classList.remove('oferta-swipe__tarjeta--arrastrando', 'oferta-swipe__tarjeta--presionada', 'oferta-swipe__tarjeta--rebote', 'oferta-swipe__tarjeta--activa');
                    });
                });
            }
        };
    }

    function iniciarInstancia(seccion) {
        var modoActual = null, instMobile = null, instNoTactil = null;
        var mq = window.matchMedia(QUERY_NO_TACTIL);

        function activarModo() {
            var nuevoModo = esNoTactil() ? 'notactil' : 'mobile';
            if (nuevoModo === modoActual) return;

            if (modoActual === 'notactil' && instNoTactil) instNoTactil.destruir();
            if (modoActual === 'mobile' && instMobile) instMobile.limpiar();

            modoActual = nuevoModo;

            if (nuevoModo === 'notactil') instNoTactil = iniciarNoTactil(seccion);
            else instMobile = instMobile ? (instMobile.posicionar(), instMobile) : iniciarMobile(seccion);
        }

        mq.addEventListener('change', activarModo);
        activarModo();
    }

    function init() { document.querySelectorAll('[data-oferta-swipe]').forEach(iniciarInstancia); }
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();